import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { Container, Grid, withStyles, Hidden } from '@material-ui/core'
import { fade } from '@material-ui/core/styles/colorManipulator'

import { colors } from 'theme'

const HeaderSkeleton = ({ classes }) => (
  <Skeleton variant="rect" animation="wave" className={classes.container}>
    <Container maxWidth="md" style={{ padding: '24px 0' }}>
      <Grid container className={classes.gridContainer}>
        <Hidden xsDown>
          <Grid item xs={2}>
            <Skeleton
              variant="rect"
              width={160}
              height={213}
              style={{ backgroundColor: fade(colors.gray50, 0.2) }}
            />
          </Grid>
          <Grid item xs={2} />
        </Hidden>
        <Grid item sm={8} style={{ height: '100%' }}>
          <Skeleton
            variant="rect"
            width={300}
            height={40}
            style={{
              backgroundColor: fade(colors.white, 0.2),
            }}
          />
        </Grid>
      </Grid>
    </Container>
  </Skeleton>
)

const styles = theme => ({
  container: {
    width: '100%',
    height: 260,
    backgroundColor: colors.navyblue,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(-2),
    [theme.breakpoints.only('xs')]: {
      height: 116,
    },
  },
  gridContainer: {
    [theme.breakpoints.only('xs')]: {
      justifyContent: 'center',
    },
  },
})

export default withStyles(styles)(HeaderSkeleton)
